import React from "react";
import './Body25.css';
import {Link} from "react-router-dom"
import picture370 from './source/picture370.png'
import picture371 from './source/picture371.png'
import picture372 from './source/picture372.png'






function Body25() {

  return (
    <div className="body25">
      <div className="body25-box1">
        <div className="body25-box2">
          <div className="body25-box3">Kudlovice Dolina</div>
          <div className="body25-box5"><div className="body25-box4"></div></div>
          <div className="body25-box6">
          <img className="body25-box6-picture" src={picture370} alt="picture1"/>
          <img className="body25-box6-picture" src={picture371} alt="picture1"/>
          <img className="body25-box6-picture" src={picture372} alt="picture1"/>
          </div>
          <div className="body25-box8"><div className="body25-box7"><Link to="/PageProjekty">Zpět</Link></div></div>
        </div> 
      </div> 
    </div>
  );
}

export default Body25;
